/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { useAmbientRouteContextSync } from './use-ambient-route-context-sync';

const AmbientCommandIntelligenceRouteSync = () => {
  useAmbientRouteContextSync();

  return null;
};

export default AmbientCommandIntelligenceRouteSync;
